import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { translate } from '../Services/translation';

const totalStatus = (addons = [], statusText = '', statusCode = '') => {
    var statusCodes = [
        'RedMax',
        'RedHighest',
        'RedHigh',
        'RedMed',
        'RedLow',
        'Yellow',
        'Green',
    ];

    var status = '';
    var addonStatus = '';
    var selectedAddons = [];
    addons
        .filter((x) => x.configVariants.some((y) => y.selected == true))
        .forEach((addon) => {
            var selected = addon.configVariants.filter((x) => x.selected == true);
            if (selected != undefined) {
                selected.forEach((sel) => {
                    selectedAddons.push(sel);
                });
            }
        });

    statusCodes.forEach((code) => {
        if (status == '') {
            var addon = selectedAddons.filter(
                (x) => x.deliveryStatus != null && x.deliveryStatus.startsWith(code)
            )[0];
            if (addon != undefined) {
                addonStatus = code;
                status = addon.deliveryText;
            }
        }
    });

    if (addonStatus) {
        var addonIndex = statusCodes.indexOf(addonStatus);
        var productIndex = statusCodes.indexOf(statusCode);
        if (productIndex < addonIndex) {
            status = statusText;
        }
    } else {
        status = statusText;
    }

    return <span className="status-text bottom-text">{status}</span>;
};

const calculatePrice = (
    addons = [],
    variantPrice = 0,
    id = '',
    priceFunc = (x) => x,
    isCampaign = false
) => {
    let price = 0;
    addons
        .filter((x) => x.configVariants.some((y) => y.selected === true))
        .forEach((addon) => {
            let selected = addon.configVariants.filter((x) => x.selected === true);

            if (selected.length > 0) {
                selected.forEach((sel) => {
                    let itemPrice = isCampaign && sel.price ? sel.price : sel.listPrice;
                    let parsedPrice = parseFloat(itemPrice);

                    if (!isNaN(parsedPrice)) {
                        price += parsedPrice;
                    }
                });
            }
        });

    let parsedVariantPrice = parseFloat(variantPrice);
    if (!isNaN(parsedVariantPrice)) {
        price += parsedVariantPrice;
    }

    let input = document.getElementById(id);
    if (input !== null) {
        let value = parseInt(input.value, 10);
        if (!isNaN(value)) {
            price *= value;
        }
    }

    return price;
};

const isDisabled = (addons = []) => {
    var disabled = false;

    addons
        .filter((x) => x.configVariants.some((y) => y.selected == true))
        .forEach((addon) => {
            var selected = addon.configVariants.filter((x) => x.selected == true);
            if (selected.some((x) => x.soldOut)) {
                disabled = true;
            }
        });

    return disabled;
};

const getTotal = (addons = []) => {
    var total = 0;

    addons.forEach((addon) => {
        var variants = addon.configVariants.filter((x) => x.selected == true);

        if (variants != undefined) {
            variants.forEach((variant) => {
                total += variant.price;
            });
        }
    });

    return total;
};

const getTotalList = (addons = []) => {
    var total = 0;

    addons.forEach((addon) => {
        var variants = addon.configVariants.filter((x) => x.selected == true);

        if (variants != undefined) {
            variants.forEach((variant) => {
                total += variant.listPrice;
            });
        }
    });

    return total;
};

const AddonProduct = ({
    addons,
    label,
    cssClass,
    onClick,
    baseProduct,
    variantClick,
    changeActiveArticle,
    canBuy,
    product,
    variantPrice,
    listPrice,
    statusCode,
    statusText,
    children,
    formattedPrice,
    formattedCampaignPrice,
    purchaseBlocked,
}) => {
    const configItemHeaderClick = (name) => {
        changeActiveArticle(name);
    };

    const addonIsSelected = addons.some(
        (addon) => addon.configVariants.some((variant) => variant.selected === true)
    );

    const getConfigurations = () => {
        return addons.map((addon, addonIndex) => {
            return (
                <div className="option-holder" key={addonIndex}>
                    <div className="header">
                        {addonIndex + 1}.{' '}
                        <a
                            onClick={() => configItemHeaderClick(addon.name)}
                            className="toggle-options"
                            style={{ cursor: 'pointer' }}
                        >
                            <span>{addon.name}</span>
                        </a>
                    </div>
                    <div
                        className={
                            addon.active || addon.active === undefined
                                ? 'options active'
                                : 'options'
                        }
                    >
                        <div className="contents">
                            {addon.configVariants.map((configVariant, configIndex) => {
                                return (
                                    <div className="single" key={configIndex}>
                                        <a
                                            style={{ cursor: configVariant.soldOut && !configVariant.selected ? 'not-allowed' : 'pointer' }}
                                            aria-disabled={configVariant.soldOut}
                                            onClick={() =>
                                                (configVariant.selected || !configVariant.soldOut) &&
                                                variantClick(addon.name, configVariant.sku)
                                            }
                                            className={[
                                                configVariant.selected ? 'active' : '',
                                                configVariant.soldOut ? 'disabled' : '',
                                            ].join(' ').trim()}
                                        >
                                            <div className="image">
                                                <img src={configVariant.defaultImageUrl} alt="" />
                                            </div>
                                            <div className="name">{configVariant.name}</div>
                                            {configVariant.deliveryStatus == 'RedMax' && (
                                                <div className="stock-info sold-out">
                                                    {configVariant.deliveryText}
                                                </div>
                                            )}
                                            {configVariant.deliveryStatus == 'RedHigh' && (
                                                <div className="stock-info out-of-stock">
                                                    {configVariant.deliveryText}
                                                </div>
                                            )}
                                            {configVariant.deliveryStatus == 'Green' && (
                                                <div className="stock-info in-stock">
                                                    {configVariant.deliveryText}
                                                </div>
                                            )}
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        });
    };

    const priceWithBenefitsBlock = () => {
        const finalPrice = calculatePrice(
            addons,
            variantPrice,
            baseProduct,
            (x) => parseFloat(x.price),
            true
        );
        const finalListPrice = calculatePrice(
            addons,
            listPrice,
            baseProduct,
            (x) => parseFloat(x.listPrice),
            false
        );

        const formattedFinalPrice = Math.round(finalPrice).toLocaleString('sv-SE');
        const formattedFinalListPrice = Math.round(finalListPrice).toLocaleString('sv-SE');

        const isCampaign = finalPrice < finalListPrice;

        return (
            <div
                className={
                    isDisabled(addons) || canBuy === 'false'
                        ? 'price-and-such disabled'
                        : 'price-and-such'
                }
            >
                <div className="price">
                    {isCampaign ? (
                        <>
                            <span className="new">
                                {addonIsSelected ?
                                    `${formattedFinalPrice} ${translate('productpage.currency')}` :
                                    formattedCampaignPrice}
                            </span>
                            <span className="old">
                                {addonIsSelected ?
                                    `${formattedFinalListPrice} ${translate('productpage.currency')}` :
                                    formattedPrice}
                            </span>
                        </>
                    ) : (
                        <span className="normal">
                            {addonIsSelected ?
                                `${formattedFinalPrice} ${translate('productpage.currency')}` :
                                formattedPrice}
                        </span>
                    )}
                </div>

                {children}

                {(isDisabled(addons) || (canBuy === 'false' && purchaseBlocked === 'true')) && (
                    <p className="product-buy-box__not-orderable">
                        {translate('productpage.notorderable', 'Produkten går för tillfället inte att beställa')}
                    </p>
                )}

                <div className="usps-holder">
                    <div className="usp">
                        <span>✓</span> {translate('productpage.priceGuarantee')}
                    </div>
                    <div className="usp">
                        <span>✓</span> {translate('productpage.freeShippingOver')}
                    </div>
                    <div className="usp">
                        <span>✓</span> {translate('productpage.deliveryGuarantee')}
                    </div>
                    <div className="usp">
                        <span>✓</span> {translate('productpage.fastDelivery')}
                    </div>
                </div>
            </div>
        );
    };

    if (getTotalList(addons) != getTotal(addons))
        return (
            <div className="main-options">
                {getConfigurations()}
                {priceWithBenefitsBlock(true)}
            </div>
        );
    else
        return (
            <div className="main-options">
                {getConfigurations()}
                {priceWithBenefitsBlock(false)}
            </div>
        );
};

export default AddonProduct;